import {Component, Inject, OnInit} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {MAT_DIALOG_DATA, MatDialogModule} from '@angular/material/dialog';
import {FormControl, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {debounceTime} from 'rxjs';
import {TagsSelectComponent} from '@q9elements/ui-kit/components';
import {SessionService, TakeUntilComponentDestroy} from '@q9elements/ui-kit/common';
import {GraphActionsService} from 'src/app/diagram-interaction/actions/graph-actions.service';
import {DraggableDialogDirective} from '../../shared/directives/draggable-dialog.directive';

@Component({
  selector: 'app-change-tags-dialog',
  templateUrl: './change-tags-dialog.component.html',
  styles: [
    `
      mat-dialog-content {
        max-height: 400px;
      }
    `
  ],
  standalone: true,
  imports: [
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    DraggableDialogDirective,
    MatDialogModule,
    TagsSelectComponent
  ]
})
export class ChangeTagsDialogComponent extends TakeUntilComponentDestroy implements OnInit {
  public teamId: string;
  public tags = new FormControl([]);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {cell: any},
    private sessionService: SessionService,
    private graphActionsService: GraphActionsService
  ) {
    super();
  }

  ngOnInit(): void {
    this.teamId = this.sessionService.teamId();
    this.updateTagForm();
  }

  private updateTagForm(): void {
    this.tags.patchValue(this.data.cell.getJson()?.tags ?? []);

    this.tags.valueChanges
      .pipe(this.takeUntilComponentDestroy(), debounceTime(800))
      .subscribe(tags => {
        this.graphActionsService.setStickerTags(tags, this.data.cell);
      });
  }
}
